export type ConnectorData = {
  reference: string,
  name: string,
  callSigns: Array<string>,
  type: string,
  apiKey: string,
}

export default class Connector {
  reference: string;
  name: string;
  callSigns: Array<string>;
  type: string;
  apiKey: string;

  constructor(data: ConnectorData) {
    this.reference = data.reference;
    this.name = data.name;
    this.callSigns = data.callSigns;
    this.type = data.type;
    this.apiKey = data.apiKey;
  }

  static parse(data: Object): Connector {
    return new Connector({
      reference: data.reference,
      name: data.name,
      callSigns: data.callSigns,
      type: data.type,
      apiKey: data.apiKey,
    });
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/connectors/domain/Connector.js